import React from "react";
import { useParams } from "react-router-dom";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import APIService from "../../Service/APIService";
import CustomHeader from "../CustomHeader/CustomHeader";
import moment from "moment";
import { Button, Input, Flex, Spin } from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TitleBar from "../../common/title-bar/title-bar";

const AccountConsignmentDashboard = () => {
  const params = useParams();
  const [consignmentData, setConsignmentData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const getConsgnmentData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getconsignmentforaccount?accountID=${params.id}`
    );
    console.log("Consignment logs Response: ", response);
    return response?.data?.data;
  };

  React.useEffect(() => {
    console.log("Account Consignment Dashboard");
    console.log("Account ID: ", params.id);
    getConsgnmentData()
      .then((data) => {
        // console.log("Consignment Data: ", data);
        let formattedData = data.map((ele) => ({
          ...ele,
          ShipDate:
            ele.ShipDate === null
              ? null
              : moment(ele.ShipDate).format("MM-DD-YYYY"),
          ExpirationDate:
            ele.ExpirationDate === null
              ? null
              : moment(ele.ExpirationDate).format("MM-DD-YYYY"),
          DaysOnConsignment:
            ele.ShipDate !== null ? (
              <span
                style={{
                  color:
                    moment().diff(moment(ele.ShipDate), "days") > 50
                      ? "red"
                      : "",
                }}
              >
                {moment().diff(moment(ele.ShipDate), "days")}
              </span>
            ) : null,
        }));
        setConsignmentData(formattedData);
      })
      .then(() => {
        setLoading(false);
      });
  }, []);
  console.log(consignmentData, "consignmentData >>>>1");
  return (
    <div>
      {/* <CustomHeader leftTopText="Welcome back!" leftBottomText="Consignment" leftBottomExtraText={`${consignmentData?.length}`} rightTopText="Logged in as Admin" rightBottomText="User" /> */}
      {/* <TitleBar
        label="Consignment"
        invoiceNumber={`${consignmentData?.length}`}
      /> */}
      <div
      // style={{
      //   display: "flex",
      //   justifyContent: "space-between",
      //   margin: "30px 0px 20px 0px",
      // }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          {/* <Button icon={<PlusOutlined />} iconPosition='end' ghost style={{ color: '#444', borderColor: '#444' }}>Set Date Range</Button> */}
          {/* {/* <Button icon={<PlusOutlined />} iconPosition='end' ghost style={{ color: '#444', borderColor: '#444' }}>Add Filter</Button> */}
        </div>

        {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Input placeholder="Search" suffix={<SearchOutlined />} style={{ height: '36px' }} />
        </div> */}
      </div>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      {!loading && (
        <GenericDashboard
          data={consignmentData}
          screen="AccountConsignmentDashboard"
        />
      )}
    </div>
  );
};

export default AccountConsignmentDashboard;
